import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import ResourceGroup from './ResourceGroup';

export default function Resources({ resources }) {
    if (!resources || !resources.length) return null;

    return (
        <aside className="listing-resources">
            {resources.map((resourceGroup, index) => (
                /* eslint-disable react/no-array-index-key */
                // The resources group does not contain unique id value from the data
                <ResourceGroup
                    group={resourceGroup}
                    key={index}
                />
                /* eslint-enable react/no-array-index-key */
            ))}
        </aside>
    );
}

Resources.propTypes = {
    resources: arrayOf(shape({
        label: string.isRequired,
        values: arrayOf(shape({
            url: string.isRequired,
            text: string.isRequired,
            filesize: string,
            icon: string
        })).isRequired
    }))
};

Resources.defaultProps = { resources: [] };
